import { Component, Inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CrmObjectInterface } from '@vendasta/crm';
import { MatButtonModule } from '@angular/material/button';
import { AssociationType } from '../../../constants';
import { TranslateByObjectTypePipe, TranslationModule } from '../../../i18n';
import { ObjectType } from '../../../tokens-and-interfaces';
import { CrmObjectDisplayService } from '../../../shared-services';
import { CommonModule } from '@angular/common';
import { GalaxyConfirmationModalModule } from '@vendasta/galaxy/confirmation-modal';
import { MatIconModule } from '@angular/material/icon';

export interface ConfirmExistingPrimaryAssociationDialogData {
  existingPrimaryObjectIds: string[];
  selectedObjects: CrmObjectInterface[];
  associationType: AssociationType;
  objectType: ObjectType;
}

export interface ConfirmExistingPrimaryAssociationDialogResult {
  continue: boolean;
  tagMap: Map<string, string[]>;
}

@Component({
  selector: 'crm-select-primary-association-modal',
  templateUrl: './confirm-existing-primary-association-modal.component.html',
  styleUrls: ['./confirm-existing-primary-association-modal.component.scss'],
  imports: [
    CommonModule,
    GalaxyConfirmationModalModule,
    MatButtonModule,
    MatIconModule,
    TranslationModule,
    TranslateByObjectTypePipe,
  ],
})
export class ConfirmExistingPrimaryAssociationModalComponent {
  protected readonly tagMap = signal(new Map<string, string[]>());
  protected readonly associations = this.data.selectedObjects;
  protected readonly objectType = this.data.objectType;
  protected readonly displayNamesByObjectId = new Map<string, string>();

  constructor(
    public dialogRef: MatDialogRef<
      ConfirmExistingPrimaryAssociationModalComponent,
      ConfirmExistingPrimaryAssociationDialogResult
    >,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmExistingPrimaryAssociationDialogData,
    private readonly objectDisplayService: CrmObjectDisplayService,
  ) {
    this.data.selectedObjects.forEach((object) => {
      this.displayNamesByObjectId.set(
        object.crmObjectId ?? '',
        this.objectDisplayService.getObjectDisplayName(this.objectType, object),
      );
    });
  }

  cancel(): void {
    this.dialogRef.close({ continue: false, tagMap: this.tagMap() } as ConfirmExistingPrimaryAssociationDialogResult);
  }

  save(): void {
    const tagMap = this.tagMap();
    for (const object of this.data.selectedObjects) {
      if (!object?.crmObjectId) {
        continue;
      }
      if (this.data.existingPrimaryObjectIds.includes(object?.crmObjectId)) {
        tagMap.set(object?.crmObjectId, []);
        continue;
      }
      tagMap.set(object?.crmObjectId, ['Primary']);
    }

    this.dialogRef.close({ continue: true, tagMap: tagMap } as ConfirmExistingPrimaryAssociationDialogResult);
  }
}
